import PartySettingsForm from "../../../../../components/PartySettings/PartySettingsForm";

const SettingsEditForm = ({ client, onCancel, onSave }) => (
  <PartySettingsForm record={client} onCancel={onCancel} onSave={onSave} />
);

export default SettingsEditForm;